import React, { useRef } from "react";
import { styled } from "styled-components";

const CategoryItem = ({ item }) => {
  const videoRef = useRef(null);
  const handleMouseEnter = () => {
    if (videoRef.current) {
      videoRef.current.play();
    }
  };

  const handleMouseLeave = () => {
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
  };

  const handleScrollToScreenComponents = () => {
    const portfoliosSection = document.getElementById("appointment");
    if (portfoliosSection) {
      portfoliosSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <Container onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      {/* <Image src={item.img}/> */}
      <Video
        muted={true}
        preload={item.img}
        src={`/vid/${item?.videoBg}`}
        ref={videoRef}
        loop
        playsInline
      />
      <Info>
        <Title>{item.title}</Title>
        <Cover />
        <Button onClick={handleScrollToScreenComponents}>QUOTE NOW</Button>
      </Info>
    </Container>
  );
};

const Cover = styled.div`
  opacity: 0;
  width: 100%;
  height: 100vh;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.5s ease;
`;

const Container = styled.div`
  flex: 1;
  align-self: flex-start;
  height: 100vh;
  position: relative;
  &:hover ${Cover} {
    opacity: 0.5;
    background-color: black;
  }
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const Video = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const Info = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
`;

const Title = styled.h1`
  color: white;
  margin-bottom: 20px;
  z-index: 2;
  font-family: "Kestrel";
  @media (max-width: 768px) {
    font-size: 14px;
    text-align: center;
    margin-bottom: 2vh;
  }
`;

const Button = styled.button`
  border: none;
  padding: 10px;
  margin-bottom: 20px;
  background-color: white;
  z-index: 2;
  cursor: pointer;
  &:hover {
    opacity: 0.6;
  }
  font-weight: 600;
  @media (max-width: 768px) {
    font-size: 10px;
    padding: 4px;
    margin-bottom: 17vh;
  }
`;

export default CategoryItem;
